import { KeyframeConfig } from "../../../models/animations.model";

const HELLO_GOODBYE_DELAY = 15;

export const getHelloGoodbyeBaseKeyframe = (
  fabricObject: any,
  opacity: number,
  duration: number,
  width: number,
  leftLine: any
): KeyframeConfig[] => {
  const letterObjects = fabricObject.getObjects().slice(1);
  let keyframeConfigs = [];

  const leftLineKeyframeConfig: KeyframeConfig = {
    option: {
      targets: [leftLine],
      keyframes: [
        {
          scaleY: 0,
          duration: 1,
          left: leftLine.left,
        },
        { scaleY: 1, left: leftLine.left, duration: duration / 2 },
        {
          scaleY: 1,
          left: leftLine.left + width,
          duration: duration,
        },
        {
          scaleY: 1,
          left: leftLine.left + width,
          duration: duration / 2,
        },
      ],
      easing: "easeOutExpo",
    },
  };

  keyframeConfigs.push(leftLineKeyframeConfig);

  const textKeyframeConfigs: KeyframeConfig[] = letterObjects.flatMap(
    (letterObject: any, index: number) => {
      return [
        {
          option: {
            keyframes: [
              {
                duration: 1,
                opacity: 0,
              },
              {
                duration: duration / 2,
                opacity,
              },
            ],
            targets: letterObject,
            delay: HELLO_GOODBYE_DELAY * (index + 1),
          },
          offset: duration / 2,
        },
      ];
    }
  );

  keyframeConfigs.push(...textKeyframeConfigs);

  return keyframeConfigs;
};
